module.exports = __webpack_public_path__ + "img/p96.f6f3c76e.png";